import { ActionButtonProps, Box, BoxProps, Form, SpacerNew, Text, TextProps } from '@jfs/ui-new'
import { ButtonNew } from '../../../components/AdminButton'
import { useCallback, useEffect } from 'react'
import { Container } from '../../../components/Container'
import { useLazyApiData, useStores } from '../../../data/store'
import { getFormData } from './FormData'

interface EntityOnboardingFormProps {
  currentStep: number
  onStepPressed: any
  initialValues?: any
  isEditable?: boolean
  fromChekerQueue?: boolean
  setIsCurrentFormValid?: (isValid: boolean) => void
  onSubmit: any
  renderActionButton?: any
  formRef?: any
  userType?: string
  onCancelOnBoarding?: any
  setAllStepValidationStatus?: (validationArray: boolean[]) => void
  allStepsValidationStatus?: boolean[]
}
export const EntityOnboardingForm = ({
  currentStep,
  onStepPressed,
  fromChekerQueue = false,
  isEditable = true,
  initialValues = {},
  setIsCurrentFormValid,
  onSubmit,
  renderActionButton,
  formRef,
  userType,
  onCancelOnBoarding,
  setAllStepValidationStatus,
  allStepsValidationStatus,
}: EntityOnboardingFormProps) => {
  const { loadInitials } = useStores((store) => ({
    loadInitials: store.entityOnboarding.loadInitials,
  }))

  const [lazyLoadInitials, loadInitialHandler] = useLazyApiData(loadInitials)

  const fethAllLovsForEntity = useCallback(() => {
    //lazyFetchLovs(...LOV_KEYS)
    lazyLoadInitials(
      initialValues?.documentUploadId ||
        ['MAKER_SEARCH_ENTITY', 'RISK_MAKER_SEARCH_ENTITY', 'DEFAULT_SEARCH_ENTITY'].includes(userType)
        ? false
        : true,
    )
  }, [initialValues?.documentUploadId, lazyLoadInitials])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(fethAllLovsForEntity, [])
  console.log('htag fetchLovsHandler', loadInitialHandler)
  useEffect(() => {
    if (loadInitialHandler?.state === 'fulfilled' && loadInitialHandler?.data?.uploadId) {
      initialValues.documentUploadId = loadInitialHandler?.data?.uploadId
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadInitialHandler?.state])

  const isFormValid = useCallback(
    (values, step) => {
      if (step === 2) {
        if (!values?.authSignatoryPoA_docs_data || values?.authSignatoryPoA_docs_data?.length === 0) {
          return false
        } else if (!values?.authSignatoryPoi_docs_data || values?.authSignatoryPoi_docs_data?.length === 0) {
          return false
        } else if (!values.authSignatoryCity || !values.authSignatoryState) {
          return false
        }
      } else if (step === 3) {
        if (!values?.businessDetailsPob_docs_data || values?.businessDetailsPob_docs_data?.length === 0) {
          return false
        } else if (!values.city || !values.state) {
          return false
        }
      } else if (step === 5) {
        if (!values?.canceled_check_docs_data || values?.canceled_check_docs_data?.length === 0) {
          return false
        }
      } else if (step === 7) {
        return allStepsValidationStatus
          ?.filter((_, index) => index !== allStepsValidationStatus.length - 1)
          ?.every((item) => item)
      }

      return true
    },
    [allStepsValidationStatus],
  )

  const actionButtons = useCallback(
    (props: ActionButtonProps) => {
      console.log('prods=', props)
      if (fromChekerQueue) {
        return null
      }
      const isCurrentFormValid = props.isCurrentFormValid && isFormValid(props?.values, currentStep)
      const allStepValidationStatus = props.allStepValidationStatus?.map(
        (item, index) => item && isFormValid(props?.values, index + 1),
      )
      if (setIsCurrentFormValid) {
        setIsCurrentFormValid(isCurrentFormValid)
      }
      if (setAllStepValidationStatus) {
        setAllStepValidationStatus(allStepValidationStatus)
      }
      return (
        <Box {...styles.footerBorder}>
          <ButtonNew
            type={'secondary'}
            height={32}
            borderRadius={4}
            borderColor={'PRIMARY'}
            title={'Cancel Onboarding'}
            onPress={onCancelOnBoarding}
          />
          <SpacerNew direction="horizontal" size={24} />
          <ButtonNew
            type={'primary'}
            height={32}
            borderRadius={4}
            disabled={!isCurrentFormValid}
            title={BUTTON_TITLES?.[currentStep]}
            onPress={() => {
              if (currentStep < 7) {
                onStepPressed(currentStep + 1)
              } else {
                //
                onSubmit(props?.values, loadInitialHandler?.data)
              }
            }}
          />
          <SpacerNew direction="horizontal" size={24} />
        </Box>
      )
    },
    [currentStep, onStepPressed],
  )

  const formData: any = getFormData(
    loadInitialHandler.state === 'fulfilled'
      ? {
          ...loadInitialHandler?.data,
          ...(initialValues?.documentUploadId && { uploadId: initialValues?.documentUploadId }),
        }
      : {},
    isEditable,
    userType,
    initialValues,
  )
  const formTitle = formData[currentStep - 1]?.title

  return (
    <Container
      isLoading={!loadInitialHandler.state || loadInitialHandler.state === 'pending' || !loadInitialHandler.data}
      errorMessage={loadInitialHandler?.data?.message}
      onRetry={fethAllLovsForEntity}>
      {formTitle && (
        <Box ph={24} pt={24}>
          <Text {...styles.title}>{formTitle}</Text>
        </Box>
      )}
      <Form
        ref={formRef}
        container={FormContainer}
        formData={formData}
        allTouched
        actionButtons={renderActionButton ?? actionButtons}
        initialStep={formData[currentStep - 1].key}
        initialValues={initialValues}
      />
    </Container>
  )
}

const styles = {
  footerBorder: {
    borderTopWidth: 1,
    borderTopColor: 'BORDER_COLOR',
    paddingVertical: 16,
    flexDirection: 'row',
    justifyContent: 'flex-end',
  } as BoxProps,
  title: {
    color: 'BLACK_21',
    fontSize: 16,
    fontFamily: 'jiotype-bold',
  } as TextProps,
}

export const FormContainer = ({ children }) => (
  <Box f={1} backgroundColor={'WHITE'}>
    {children}
  </Box>
)

const BUTTON_TITLES = {
  1: 'Proceed To Authorised Signatory',
  2: 'Proceed To Business Details',
  3: 'Proceed To Other Business Details',
  4: 'Proceed To Bank Details',
  5: 'Proceed To Document Upload',
  6: 'Proceed To Fee/Package Details',
  7: 'Submit',
}
